/**
 * Set active feature item for specific part ID
 * @param {string} partId - Part ID identifier
 * @param {number} itemIndex - Index of active item
 * @returns {Object} Redux action
 */
import {RESET_ACTIVE_FEATURE_ITEM, SET_ACTIVE_FEATURE_ITEM} from "./actionTypes";

export const setActiveFeatureItem = (partId, itemIndex) => ({
  type: SET_ACTIVE_FEATURE_ITEM,
  payload: {
    partId,
    itemIndex
  }
});

/**
 * Reset active feature item for specific part ID
 * @param {string} partId - Part ID identifier
 * @returns {Object} Redux action
 */
export const resetActiveFeatureItem = (partId) => ({
  type: RESET_ACTIVE_FEATURE_ITEM,
  payload: {
    partId
  }
});

/**
 * Reset all active feature items
 * @returns {Object} Redux action
 */
export const resetAllActiveFeatureItems = () => ({
  type: RESET_ACTIVE_FEATURE_ITEM,
  payload: {
    partId: null // null means reset all
  }
});
